<div class="ap-display-flex ap-justify-content-end">
    <p class="ap-small" [ngClass]="fromClient() ? 'ap-margin-0 ap-margin-right-1' : 'ap-margin-0 ap-margin-right-4'">
        {{ formattedTime() }}
    </p>
</div>
